// eslint-disable-next-line import/prefer-default-export
export const GetLeadershipStaffDevelopmentSelector = ({
  leadershipStaffDevelopment: { GetLeadershipStaffDevelopment }
}) => GetLeadershipStaffDevelopment;

export const PostLeadershipStaffDevelopmentSelector = ({
  leadershipStaffDevelopment: { PostLeadershipStaffDevelopment }
}) => PostLeadershipStaffDevelopment;
